<template>
  <div class="login-page">
    <!-- Banner -->
    <div class="banner">
      <div class="banner-content">
        <h1 class="banner-title">Online Library for Green Inclusive Finance</h1>
      </div>
      <div class="banner-decoration" aria-hidden="true">
        <div class="deco-circle deco-1"></div>
        <div class="deco-circle deco-2"></div>
        <div class="deco-circle deco-3"></div>
      </div>
    </div>

    <!-- Login card -->
    <div class="login-container">
      <div class="login-card">
        <button type="button" class="btn-back" @click="$router.push('/papers/search')">
          <i class="fa fa-arrow-left"></i>
          Back
        </button>
        <form @submit.prevent="login">
          <!-- Error message -->
          <div v-if="!isHidden" class="error-message">
            <i class="fa fa-exclamation-circle"></i>
            You have entered an invalid email or password
          </div>

          <!-- Email field -->
          <div class="form-group">
            <label class="form-label">Email Address</label>
            <input
              type="email"
              class="form-input"
              placeholder="Enter your email…"
              v-model="email"
              required
            />
          </div>

          <!-- Password field -->
          <div class="form-group">
            <label class="form-label">Password</label>
            <input
              type="password"
              class="form-input"
              placeholder="Enter your password…"
              v-model="password"
              required
            />
          </div>

          <!-- Submit button -->
          <button type="submit" class="btn-primary">Login</button>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
import { LOGIN_MUTATION } from '@/graphql'

export default {
  name: 'LogIn',
  data () {
    return {
      email: '',
      password: '',
      isHidden: true
    }
  },
  methods: {
    login () {
      this.isHidden = true
      this.$apollo
        .mutate({
          mutation: LOGIN_MUTATION,
          variables: {
            email: this.email,
            password: this.password
          }
        })
        .then(response => {
          this.isHidden = true
          // save user token to localstorage
          localStorage.setItem('app-token', JSON.stringify(response.data))
          // redirect user
          this.$router.push('/papers/search')
        }).catch(error => {
          this.isHidden = false
          console.log(this.graphQLErrorMessages(error))
        })
    }
  }
}
</script>

<style scoped>
@import url('https://fonts.googleapis.com/css2?family=Poppins:wght@400;500;600;700;800&display=swap');

/* ── Page shell ── */
.login-page {
  font-family: 'Poppins', sans-serif;
  background: #f8fbf9;
  min-height: 100vh;
  display: flex;
  flex-direction: column;
}

/* ── Banner ── */
.banner {
  background-color: #1b3d2f;
  border-radius: 0 0 12px 12px;
  padding: 3rem 2.5rem;
  position: relative;
  overflow: hidden;
}

.banner-content {
  position: relative;
  z-index: 2;
}

.banner-title {
  color: #ffffff;
  font-size: 36px;
  font-weight: 800;
  line-height: 1.2;
  margin: 0;
}

.banner {
  background-image: url('../../assets/banner.jpg');
  background-size: cover;
  background-position: center;
  position: relative;
}

.banner::before {
  content: '';
  position: absolute;
  inset: 0;
  background: rgba(27, 61, 47, 0.82);
  border-radius: 0 0 12px 12px;
  z-index: 1;
}

.banner-content, .banner-decoration {
  position: relative;
  z-index: 2;
}

/* Decorative circles */
.banner-decoration {
  position: absolute;
  top: 0;
  right: 0;
  width: 260px;
  height: 100%;
  z-index: 1;
}

.deco-circle {
  position: absolute;
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.04);
  border: 1px solid rgba(255, 255, 255, 0.06);
}

.deco-1 {
  width: 200px;
  height: 200px;
  top: -60px;
  right: -40px;
}

.deco-2 {
  width: 140px;
  height: 140px;
  top: 20px;
  right: 100px;
}

.deco-3 {
  width: 80px;
  height: 80px;
  bottom: -20px;
  right: 60px;
}

/* ── Login container ── */
.login-container {
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 2rem;
}

.login-card {
  background: #ffffff;
  border: 1px solid #d5e8db;
  border-radius: 10px;
  padding: 2.5rem;
  width: 100%;
  max-width: 400px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
}

.btn-back {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 1.5rem;
  padding: 0.75rem 1rem;
  border: 1px solid #c8dbd3;
  border-radius: 8px;
  background: #f7fbf8;
  color: #2c5542;
  font-weight: 600;
  cursor: pointer;
  transition: background 0.15s, border-color 0.15s;
}

.btn-back:hover {
  background: #eef6ef;
  border-color: #a8c8b7;
}

/* ── Error message ── */
.error-message {
  background: #fcebeb;
  color: #a32d2d;
  border-radius: 7px;
  padding: 12px 14px;
  font-size: 13px;
  margin-bottom: 20px;
  display: flex;
  align-items: center;
  gap: 10px;
}

.error-message i {
  flex-shrink: 0;
}

/* ── Form ── */
.form-group {
  margin-bottom: 18px;
}

.form-label {
  font-size: 12px;
  font-weight: 700;
  color: #7aaa8d;
  letter-spacing: 0.07em;
  text-transform: uppercase;
  display: block;
  margin-bottom: 8px;
}

.form-input {
  width: 100%;
  height: 42px;
  border: 1px solid #c8dbd3;
  border-radius: 7px;
  padding: 0 14px;
  font-family: 'Poppins', sans-serif;
  font-size: 13px;
  color: #1b3d2f;
  background: #f7fbf8;
  outline: none;
  transition: border-color 0.15s, background 0.15s;
}

.form-input:focus {
  border-color: #2d6a4f;
  background: #ffffff;
}

.form-input::placeholder {
  color: #9bbfae;
}

/* ── Button ── */
.btn-primary {
  width: 100%;
  height: 44px;
  background: #1b3d2f;
  color: #ffffff;
  border: none;
  border-radius: 7px;
  font-family: 'Poppins', sans-serif;
  font-size: 13px;
  font-weight: 600;
  cursor: pointer;
  transition: background 0.15s;
  margin-top: 20px;
}

.btn-primary:hover {
  background: #2d6a4f;
}

.btn-primary:active {
  background: #1b3d2f;
}

/* ── Responsive ── */
@media (max-width: 768px) {
  .banner {
    border-radius: 0;
    padding: 2rem 1.5rem;
  }

  .banner-title {
    font-size: 28px;
  }

  .banner-decoration {
    display: none;
  }

  .login-container {
    padding: 1rem;
  }

  .login-card {
    padding: 1.5rem;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Admin/LogIn.vue